import React from 'react';
import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';
import { Box } from '@mui/material';
import { MappedLeaveItem } from '../../shared/types';
import { TextField } from 'framework/ui/field';

const BalancesLeavesField = ({ value, source }: { value?: MappedLeaveItem; source: keyof MappedLeaveItem }) => {
  const dateValue = value?.[source];

  if (!dateValue || typeof dateValue !== 'string') return null;

  const formatDate = (dateString: string) => moment(dateString).format(DATE_FORMAT.SIMPLE);
  const formattedDate = formatDate(dateValue);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField value={formattedDate} />
    </Box>
  );
};

export default BalancesLeavesField;
